// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.absolute {
  position: absolute
}

.relative {
  position: relative
}

.bottom-0 {
  bottom: 0px
}

.left-0 {
  left: 0px
}

.right-0 {
  right: 0px
}

.right-1 {
  right: 0.25rem
}

.top-0 {
  top: 0px
}

.top-1 {
  top: 0.25rem
}

.top-\\[40px\\] {
  top: 40px
}

.z-10 {
  z-index: 10
}

.my-10 {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem
}

.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem
}

.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem
}

.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem
}

.-mb-px {
  margin-bottom: -1px
}

.mb-2 {
  margin-bottom: 0.5rem
}

.mb-3 {
  margin-bottom: 0.75rem
}

.ml-1 {
  margin-left: 0.25rem
}

.ml-2 {
  margin-left: 0.5rem
}

.ml-3 {
  margin-left: 0.75rem
}

.ml-4 {
  margin-left: 1rem
}

.mr-2 {
  margin-right: 0.5rem
}

.mt-1 {
  margin-top: 0.25rem
}

.mt-10 {
  margin-top: 2.5rem
}

.mt-2 {
  margin-top: 0.5rem
}

.mt-20 {
  margin-top: 5rem
}

.mt-4 {
  margin-top: 1rem
}

.mt-6 {
  margin-top: 1.5rem
}

.mt-8 {
  margin-top: 2rem
}

.box-border {
  box-sizing: border-box
}

.flex {
  display: flex
}

.inline-flex {
  display: inline-flex
}

.hidden {
  display: none
}

.h-20 {
  height: 5rem
}

.h-28 {
  height: 7rem
}

.h-4 {
  height: 1rem
}

.h-5 {
  height: 1.25rem
}

.h-\\[12px\\] {
  height: 12px
}

.h-\\[340px\\] {
  height: 340px
}

.h-full {
  height: 100%
}

.max-h-52 {
  max-height: 13rem
}

.min-h-\\[34px\\] {
  min-height: 34px
}

.w-0 {
  width: 0px
}

.w-10 {
  width: 2.5rem
}

.w-32 {
  width: 8rem
}

.w-5 {
  width: 1.25rem
}

.w-\\[12px\\] {
  width: 12px
}

.w-auto {
  width: auto
}

.w-full {
  width: 100%
}

.flex-1 {
  flex: 1 1 0%
}

.cursor-pointer {
  cursor: pointer
}

.flex-col {
  flex-direction: column
}

.items-center {
  align-items: center
}

.justify-center {
  justify-content: center
}

.justify-between {
  justify-content: space-between
}

.gap-1 {
  gap: 0.25rem
}

.gap-2 {
  gap: 0.5rem
}

.gap-4 {
  gap: 1rem
}

.gap-x-2 {
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem
}

.overflow-auto {
  overflow: auto
}

.overflow-hidden {
  overflow: hidden
}

.overflow-x-auto {
  overflow-x: auto
}

.overflow-y-hidden {
  overflow-y: hidden
}

.whitespace-nowrap {
  white-space: nowrap
}

.rounded {
  border-radius: 0.25rem
}

.rounded-full {
  border-radius: 9999px
}

.rounded-md {
  border-radius: 0.375rem
}

.border {
  border-width: 1px
}

.border-2 {
  border-width: 2px
}

.border-x {
  border-left-width: 1px;
  border-right-width: 1px
}

.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px
}

.border-b {
  border-bottom-width: 1px
}

.border-b-2 {
  border-bottom-width: 2px
}

.border-b-4 {
  border-bottom-width: 4px
}

.border-r {
  border-right-width: 1px
}

.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity))
}

.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity))
}

.border-b-orange-500 {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(249 115 22 / var(--tw-border-opacity))
}

.bg-indigo-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity))
}

.bg-orange-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity))
}

.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity))
}

.bg-cover {
  background-size: cover
}

.object-fill {
  -o-object-fit: fill;
     object-fit: fill
}

.p-1 {
  padding: 0.25rem
}

.p-2 {
  padding: 0.5rem
}

.p-4 {
  padding: 1rem
}

.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem
}

.px-12 {
  padding-left: 3rem;
  padding-right: 3rem
}

.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem
}

.px-8 {
  padding-left: 2rem;
  padding-right: 2rem
}

.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem
}

.pb-6 {
  padding-bottom: 1.5rem
}

.pl-4 {
  padding-left: 1rem
}

.pr-2 {
  padding-right: 0.5rem
}

.pr-8 {
  padding-right: 2rem
}

.text-center {
  text-align: center
}

.font-sans {
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"
}

.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem
}

.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem
}

.text-6xl {
  font-size: 3.75rem;
  line-height: 1
}

.text-7xl {
  font-size: 4.5rem;
  line-height: 1
}

.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem
}

.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem
}

.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem
}

.text-xs {
  font-size: 0.75rem;
  line-height: 1rem
}

.font-bold {
  font-weight: 700
}

.font-semibold {
  font-weight: 600
}

.tracking-wider {
  letter-spacing: 0.05em
}

.text-\\[\\#1a3063\\] {
  --tw-text-opacity: 1;
  color: rgb(26 48 99 / var(--tw-text-opacity))
}

.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity))
}

.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity))
}

.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity))
}

.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity))
}

.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}

.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}

.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms
}

.duration-300 {
  transition-duration: 300ms
}

.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity))
}

.hover\\:bg-indigo-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity))
}`, "",{"version":3,"sources":["webpack://./src/output.css"],"names":[],"mappings":"AAAA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,uBAAuB;OAClB;AACP;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;KAChB;AACL;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,0EAA0E;EAC1E,8FAA8F;EAC9F;AACF;;AAEA;EACE,+EAA+E;EAC/E,mGAAmG;EACnG;AACF;;AAEA;EACE;AACF;;AAEA;EACE,wBAAwB;EACxB,wDAAwD;EACxD;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF","sourcesContent":[".absolute {\n  position: absolute\n}\n\n.relative {\n  position: relative\n}\n\n.bottom-0 {\n  bottom: 0px\n}\n\n.left-0 {\n  left: 0px\n}\n\n.right-0 {\n  right: 0px\n}\n\n.right-1 {\n  right: 0.25rem\n}\n\n.top-0 {\n  top: 0px\n}\n\n.top-1 {\n  top: 0.25rem\n}\n\n.top-\\[40px\\] {\n  top: 40px\n}\n\n.z-10 {\n  z-index: 10\n}\n\n.my-10 {\n  margin-top: 2.5rem;\n  margin-bottom: 2.5rem\n}\n\n.my-2 {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem\n}\n\n.my-4 {\n  margin-top: 1rem;\n  margin-bottom: 1rem\n}\n\n.my-6 {\n  margin-top: 1.5rem;\n  margin-bottom: 1.5rem\n}\n\n.-mb-px {\n  margin-bottom: -1px\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem\n}\n\n.mb-3 {\n  margin-bottom: 0.75rem\n}\n\n.ml-1 {\n  margin-left: 0.25rem\n}\n\n.ml-2 {\n  margin-left: 0.5rem\n}\n\n.ml-3 {\n  margin-left: 0.75rem\n}\n\n.ml-4 {\n  margin-left: 1rem\n}\n\n.mr-2 {\n  margin-right: 0.5rem\n}\n\n.mt-1 {\n  margin-top: 0.25rem\n}\n\n.mt-10 {\n  margin-top: 2.5rem\n}\n\n.mt-2 {\n  margin-top: 0.5rem\n}\n\n.mt-20 {\n  margin-top: 5rem\n}\n\n.mt-4 {\n  margin-top: 1rem\n}\n\n.mt-6 {\n  margin-top: 1.5rem\n}\n\n.mt-8 {\n  margin-top: 2rem\n}\n\n.box-border {\n  box-sizing: border-box\n}\n\n.flex {\n  display: flex\n}\n\n.inline-flex {\n  display: inline-flex\n}\n\n.hidden {\n  display: none\n}\n\n.h-20 {\n  height: 5rem\n}\n\n.h-28 {\n  height: 7rem\n}\n\n.h-4 {\n  height: 1rem\n}\n\n.h-5 {\n  height: 1.25rem\n}\n\n.h-\\[12px\\] {\n  height: 12px\n}\n\n.h-\\[340px\\] {\n  height: 340px\n}\n\n.h-full {\n  height: 100%\n}\n\n.max-h-52 {\n  max-height: 13rem\n}\n\n.min-h-\\[34px\\] {\n  min-height: 34px\n}\n\n.w-0 {\n  width: 0px\n}\n\n.w-10 {\n  width: 2.5rem\n}\n\n.w-32 {\n  width: 8rem\n}\n\n.w-5 {\n  width: 1.25rem\n}\n\n.w-\\[12px\\] {\n  width: 12px\n}\n\n.w-auto {\n  width: auto\n}\n\n.w-full {\n  width: 100%\n}\n\n.flex-1 {\n  flex: 1 1 0%\n}\n\n.cursor-pointer {\n  cursor: pointer\n}\n\n.flex-col {\n  flex-direction: column\n}\n\n.items-center {\n  align-items: center\n}\n\n.justify-center {\n  justify-content: center\n}\n\n.justify-between {\n  justify-content: space-between\n}\n\n.gap-1 {\n  gap: 0.25rem\n}\n\n.gap-2 {\n  gap: 0.5rem\n}\n\n.gap-4 {\n  gap: 1rem\n}\n\n.gap-x-2 {\n  -moz-column-gap: 0.5rem;\n       column-gap: 0.5rem\n}\n\n.overflow-auto {\n  overflow: auto\n}\n\n.overflow-hidden {\n  overflow: hidden\n}\n\n.overflow-x-auto {\n  overflow-x: auto\n}\n\n.overflow-y-hidden {\n  overflow-y: hidden\n}\n\n.whitespace-nowrap {\n  white-space: nowrap\n}\n\n.rounded {\n  border-radius: 0.25rem\n}\n\n.rounded-full {\n  border-radius: 9999px\n}\n\n.rounded-md {\n  border-radius: 0.375rem\n}\n\n.border {\n  border-width: 1px\n}\n\n.border-2 {\n  border-width: 2px\n}\n\n.border-x {\n  border-left-width: 1px;\n  border-right-width: 1px\n}\n\n.border-y {\n  border-top-width: 1px;\n  border-bottom-width: 1px\n}\n\n.border-b {\n  border-bottom-width: 1px\n}\n\n.border-b-2 {\n  border-bottom-width: 2px\n}\n\n.border-b-4 {\n  border-bottom-width: 4px\n}\n\n.border-r {\n  border-right-width: 1px\n}\n\n.border-gray-200 {\n  --tw-border-opacity: 1;\n  border-color: rgb(229 231 235 / var(--tw-border-opacity))\n}\n\n.border-gray-300 {\n  --tw-border-opacity: 1;\n  border-color: rgb(209 213 219 / var(--tw-border-opacity))\n}\n\n.border-b-orange-500 {\n  --tw-border-opacity: 1;\n  border-bottom-color: rgb(249 115 22 / var(--tw-border-opacity))\n}\n\n.bg-indigo-500 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(99 102 241 / var(--tw-bg-opacity))\n}\n\n.bg-orange-600 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(234 88 12 / var(--tw-bg-opacity))\n}\n\n.bg-white {\n  --tw-bg-opacity: 1;\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity))\n}\n\n.bg-cover {\n  background-size: cover\n}\n\n.object-fill {\n  -o-object-fit: fill;\n     object-fit: fill\n}\n\n.p-1 {\n  padding: 0.25rem\n}\n\n.p-2 {\n  padding: 0.5rem\n}\n\n.p-4 {\n  padding: 1rem\n}\n\n.px-1 {\n  padding-left: 0.25rem;\n  padding-right: 0.25rem\n}\n\n.px-12 {\n  padding-left: 3rem;\n  padding-right: 3rem\n}\n\n.px-2 {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem\n}\n\n.px-3 {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem\n}\n\n.px-8 {\n  padding-left: 2rem;\n  padding-right: 2rem\n}\n\n.py-1 {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem\n}\n\n.py-2 {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem\n}\n\n.pb-6 {\n  padding-bottom: 1.5rem\n}\n\n.pl-4 {\n  padding-left: 1rem\n}\n\n.pr-2 {\n  padding-right: 0.5rem\n}\n\n.pr-8 {\n  padding-right: 2rem\n}\n\n.text-center {\n  text-align: center\n}\n\n.font-sans {\n  font-family: ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"\n}\n\n.text-2xl {\n  font-size: 1.5rem;\n  line-height: 2rem\n}\n\n.text-3xl {\n  font-size: 1.875rem;\n  line-height: 2.25rem\n}\n\n.text-6xl {\n  font-size: 3.75rem;\n  line-height: 1\n}\n\n.text-7xl {\n  font-size: 4.5rem;\n  line-height: 1\n}\n\n.text-lg {\n  font-size: 1.125rem;\n  line-height: 1.75rem\n}\n\n.text-sm {\n  font-size: 0.875rem;\n  line-height: 1.25rem\n}\n\n.text-xl {\n  font-size: 1.25rem;\n  line-height: 1.75rem\n}\n\n.text-xs {\n  font-size: 0.75rem;\n  line-height: 1rem\n}\n\n.font-bold {\n  font-weight: 700\n}\n\n.font-semibold {\n  font-weight: 600\n}\n\n.tracking-wider {\n  letter-spacing: 0.05em\n}\n\n.text-\\[\\#1a3063\\] {\n  --tw-text-opacity: 1;\n  color: rgb(26 48 99 / var(--tw-text-opacity))\n}\n\n.text-gray-300 {\n  --tw-text-opacity: 1;\n  color: rgb(209 213 219 / var(--tw-text-opacity))\n}\n\n.text-gray-400 {\n  --tw-text-opacity: 1;\n  color: rgb(156 163 175 / var(--tw-text-opacity))\n}\n\n.text-gray-500 {\n  --tw-text-opacity: 1;\n  color: rgb(107 114 128 / var(--tw-text-opacity))\n}\n\n.text-gray-700 {\n  --tw-text-opacity: 1;\n  color: rgb(55 65 81 / var(--tw-text-opacity))\n}\n\n.text-white {\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity))\n}\n\n.shadow {\n  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)\n}\n\n.shadow-lg {\n  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)\n}\n\n.filter {\n  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)\n}\n\n.transition-all {\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms\n}\n\n.duration-300 {\n  transition-duration: 300ms\n}\n\n.hover\\:bg-gray-200:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(229 231 235 / var(--tw-bg-opacity))\n}\n\n.hover\\:bg-indigo-500:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(99 102 241 / var(--tw-bg-opacity))\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
